import backgroundImage from "../../_images/hero-large.webp"; // Update the path accordingly
import { ReactComponent as BottomSvg } from "../../_images/background-wave.svg"; // Update the path accordingly

// Elements
import { Container, Wave } from "./Hero.elements";

export default function Hero() {
  return (
    <Container
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <Wave>
        <BottomSvg />
      </Wave>
    </Container>
  );
}
